var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranscript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89278 16.1665C4.89278 15.4797 5.44042 14.923 6.11597 14.923H15.9015C16.5771 14.923 17.1247 15.4797 17.1247 16.1665C17.1247 16.8534 16.5771 17.4101 15.9015 17.4101H6.11597C5.44042 17.4101 4.89278 16.8534 4.89278 16.1665Z",
    fill: "#C3C3C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7943 9.94864C21.4699 9.94864 22.0175 10.5054 22.0175 11.1922C22.0175 11.8791 21.4699 12.4358 20.7943 12.4358H11.0087C10.3332 12.4358 9.78555 11.8791 9.78555 11.1922C9.78555 10.5054 10.3332 9.94864 11.0087 9.94864H20.7943Z",
    fill: "#C3C3C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3479 16.1665C18.3479 15.4797 18.8955 14.923 19.5711 14.923H20.7943C21.4699 14.923 22.0175 15.4797 22.0175 16.1665C22.0175 16.8534 21.4699 17.4101 20.7943 17.4101H19.5711C18.8955 17.4101 18.3479 16.8534 18.3479 16.1665Z",
    fill: "#C3C3C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33916 9.94864C8.01471 9.94864 8.56236 10.5054 8.56236 11.1922C8.56236 11.8791 8.01471 12.4358 7.33916 12.4358H6.11597C5.44042 12.4358 4.89278 11.8791 4.89278 11.1922C4.89278 10.5054 5.44042 9.94864 6.11597 9.94864H7.33916Z",
    fill: "#C3C3C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66958 0C1.64293 0 0 1.67031 0 3.73074V18.6537C0 20.7142 1.64293 22.3844 3.66958 22.3844H23.2407C25.2674 22.3844 26.9103 20.7142 26.9103 18.6537V3.73074C26.9103 1.67031 25.2674 0 23.2407 0H3.66958ZM23.2407 2.48716H3.66958C2.99404 2.48716 2.44639 3.04394 2.44639 3.73074V18.6537C2.44639 19.3405 2.99404 19.8973 3.66958 19.8973H23.2407C23.9163 19.8973 24.4639 19.3405 24.4639 18.6537V3.73074C24.4639 3.04392 23.9163 2.48716 23.2407 2.48716Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscript);
export default __webpack_public_path__ + "static/media/transcript.4f143a7955159f2417293680ac9e8e35.svg";
export { ForwardRef as ReactComponent };